import React from 'react';

function Privacy() {
  return (
    <div className="privacy-container">
      <h1>Politica de confidențialitate</h1>
      <div className="privacy-content">
        <section>
          <h2>Introducere</h2>
          <p>
            Această politică de confidențialitate explică modul în care platforma Aleph (alephmedia.ro) colectează, utilizează și protejează informațiile personale ale utilizatorilor.
          </p>
        </section>

        <section>
          <h2>Colectarea informațiilor</h2>
          <p>
            Colectăm informații personale doar atunci când acestea sunt furnizate voluntar de către 
            utilizatori. Aceste informații pot include numele, adresa de e-mail, numărul de telefon 
            și alte date necesare pentru furnizarea serviciilor noastre.
          </p>
        </section>

        <section>
          <h2>Utilizarea informațiilor</h2>
          <p>
            Informațiile colectate sunt utilizate pentru:
          </p>
          <ul>
            <li>Furnizarea și îmbunătățirea serviciilor noastre</li>
            <li>Comunicarea cu utilizatorii</li>
            <li>Personalizarea experienței de utilizare</li>
            <li>Procesarea plăților și comenzilor</li>
            <li>Conformarea cu obligațiile legale</li>
          </ul>
        </section>

        <section>
          <h2>Securitatea datelor</h2>
          <p>
            Implementăm măsuri de securitate adecvate pentru a proteja informațiile personale împotriva 
            accesului neautorizat, modificării, dezvăluirii sau distrugerii. Aceste măsuri includ:
          </p>
          <ul>
            <li>Criptarea datelor sensibile</li>
            <li>Controlul accesului la informații</li>
            <li>Monitorizarea securității sistemelor</li>
            <li>Formarea angajaților în domeniul securității datelor</li>
          </ul>
        </section>

        <section>
          <h2>Drepturile utilizatorilor</h2>
          <p>
            Conform GDPR, utilizatorii au următoarele drepturi:
          </p>
          <ul>
            <li>Dreptul de acces la datele personale</li>
            <li>Dreptul la rectificarea datelor</li>
            <li>Dreptul la ștergerea datelor</li>
            <li>Dreptul la restricționarea procesării</li>
            <li>Dreptul la portabilitatea datelor</li>
            <li>Dreptul de opoziție</li>
          </ul>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Pentru orice întrebări sau solicitări legate de politica de confidențialitate, vă rugăm să ne 
            contactați la:
          </p>
          <p>
            Email: gdpr@alephnews.ro<br />
            Telefon: +40 21 310 00 00
          </p>
        </section>
      </div>
    </div>
  );
}

export default Privacy; 